import styled from "styled-components"

import { colors, Text } from "@minuthq/meatball-ui-react"

import { TClockType } from "src/data/user/user"
import { useTranslate } from "src/i18n/useTranslate"
import { Box } from "src/ui/Graphs/GenericTooltip"
import { spacing } from "src/ui/spacing"
import { formatDate } from "src/utils/l10n"

export function GanttChartTooltip({
  startDate,
  endDate,
  label,
  clockType,
  timezone,
}: {
  startDate: string
  endDate: string
  label: string
  clockType: TClockType
  timezone?: string
}) {
  const { tPlaceholder } = useTranslate()

  return (
    <Box>
      <Header>
        <Text variant="subtitleS">{label}</Text>
      </Header>
      <Content>
        <div>
          <Text variant="bodyS" color="tertiary" as="span">
            {tPlaceholder("Start")}:{" "}
            {formatDate({ date: startDate, clockType, timezone })}
          </Text>
        </div>

        <div>
          <Text variant="bodyS" color="tertiary" as="span">
            {tPlaceholder("End")}:{" "}
            {formatDate({ date: endDate, clockType, timezone })}
          </Text>
        </div>
      </Content>
    </Box>
  )
}

const Header = styled.div`
  border-radius: 0.25rem 0.25rem 0 0;
  padding: ${spacing.S} ${spacing.M};
  background: ${colors.primaryLight};
`

const Content = styled.div`
  display: grid;
  gap: ${spacing.XS};
  padding: ${spacing.S} ${spacing.M};
`
